<template>
  <div id="form">
    <h2>Форма заявки</h2>
    <div :class="['flex-column', errors.first('credit_sum') ? 'error': '']">
      <label for="credit_sum">{{ formTitle }}</label>

        <input type="tel"
          name="credit_sum"
          id="credit_sum"
          v-model="sum"
          v-validate="{required:true,is_valid_sum: true}"
          v-mask="['## ###', '### ###', '# ######']"
          :disabled="disabled"
        />
      <div v-if="errors.first('credit_sum')" class="error-msg">{{ errors.first('credit_sum') }}</div>
    </div>

    <div class="flex-column">
      <h3>Срок</h3>
      <div class="button-groups">
        <button v-for="(item, i) in dataItems"
                :key="i"
                @click="setMonth(item)"
                :class="[month === item.duration ? 'button-selected' : '']">
                {{ item.duration }} мес.
        </button>
      </div>
    </div>

    <div :class="['total_counter', isValidSum ? 'show' : '' ]">
      <h3>Ежемесячный платеж</h3>
      <p><b>{{ Math.round(calculatePayment) }} тенге</b> {{ isInstall }}</p>
    </div>

    <div :class="['flex-column', errors.first('client_name') ? 'error': '']">
      <label for="client_name">Фамилия Имя Отчество</label>

      <input type="text"
        id="client_name"
        v-model="name"
        v-validate="{required: true, min: 3, max: 128, alpha_spaces: true}"
        name="client_name"
        maxlength="128"
      />
      <div v-if="errors.first('client_name')" class="error-msg">{{ errors.first('client_name') }}</div>
    </div>

    <div :class="['flex-column', errors.first('id_num') ? 'error': '']">
      <label for="id_num">ИИН</label>

      <input type="tel"
        id="id_num"
        v-model="idn"
        v-validate="{length:12, required:true, is_adult: true}"
        name="id_num"
        maxlength="12"
      />

      <div v-if="errors.first('id_num')" class="error-msg">{{ errors.first('id_num') }}</div>
    </div>

    <div :class="['flex-column', errors.first('phone_num') ? 'error': '']">
      <label for="phone_num">Номер телефона</label>
      <div class="phone_num_holder">
        <label for="phone_num">+7</label>

          <input type="tel"
            id="phone_num"
            v-model="phone"
            name="phone_num"
            v-validate="{required:true, is_valid_phone: true}"
            v-mask="'(###) ###-##-##'"
          />

      </div>
      <div v-if="errors.first('phone_num')" class="error-msg">{{ errors.first('phone_num') }}</div>
    </div>

    <div class="form-row agreement-check">
      <div class="agreement-check-holder">
        <div :class="[termsAgree ? 'checked' : '' ,'checkbox']" @click="termsChange()"></div>
        <p>Даю согласие на сбор, хранение и обработку персональных данных в соответствии с Законом РК "О персональных данных и их защите". ДБ АО «Банк Хоум Кредит» Лицензия № 1.2.36/40 от 11.01.2016 г., выдана Национальным Банком РК</p>
      </div>
      <div class="error-msg-terms" v-if="termsError">Чтобы продолжить оформление заявки, вам небходимо поставить галочку.</div>
    </div>
    <button class="submit" @click="sendForm()" :disabled="disabled">
      Отправить заявку
    </button>
  </div>
</template>

<script>
import { Validator } from 'vee-validate'

export default {
  name: 'TheForm',
  data () {
    return {
      month: null,
      termsAgree: false,
      sum: null,
      formatedSum: null,
      name: null,
      idn: null,
      phone: null,
      validPhone: false,
      termsError: false,
      disabled: false,
      coef: null,
      dataItems: [],
      appNum: '',
      isAdult: false,
      cutedIdn: '',
      isValidSum: false,
      isInstall: null,
      formTitle: null
    }
  },
  created () {
    Validator.extend('is_adult', {
      getMessage: field => 'Минимальный возраст заявителя должен быть 18 лет',
      validate: value => this.isAdult
    })
    Validator.extend('is_valid_phone', {
      getMessage: field => 'Неверно введен номер телефона',
      validate: value => this.validPhone
    })
    Validator.extend('is_valid_sum', {
      getMessage: field => 'Сумма от 10 000 тг. до 1 500 000 тг.',
      validate: value => this.isValidSum
    })
  },
  mounted () {
    let self = this

    if (self.$route.params.amount) {
      self.sum = self.$route.params.amount
      // this.disabled = true
    } else {
      self.sum = null
      // this.disabled = false
    }

    self.axios.get(
      './data_config.php'
    )
      .then((response) => {
        self.formTitle = response.data.loanTitle
        self.$store.dispatch('setHeaderText', response.data.headerText)
        self.$store.dispatch('setSuccessText', response.data.successText)
        response.data.dataArray.forEach(element => {
          if (element.coef) {
            self.dataItems.push(element)
          }
        })
        self.month = self.dataItems[0].duration
        self.coef = self.dataItems[0].coef
        self.isInstall = self.dataItems[0].isInstall === true ? 'Рассрочка' : 'Кредит'
      })
      .catch((error) => {
        console.log(error)
      })
  },
  methods: {
    termsChange () {
      this.termsAgree = !this.termsAgree
    },
    setMonth (value) {
      let self = this
      self.month = value.duration
      self.coef = value.coef
      self.isInstall = value.isInstall === true ? 'Рассрочка' : 'Кредит'
    },
    sendForm () {
      this.disabled = true
      this.makeid()
      if (!this.termsAgree) {
        this.termsError = true
      } else {
        this.termsError = false
      }
      this.$validator.validate().then(result => {
        if (!result) {
          this.disabled = false
        } else {
          let formData = {
            appNum: this.appNum,
            idn: this.idn,
            name: this.name,
            id: this.$route.params.amount,
            phone: this.phone.replace(/[^0-9]/g, ''),
            sum: this.sum.replace(/[^0-9]/g, '')
          }
          this.axios.post(
            './sendAppl.php',
            formData,
            { headers:
             { 'Content-Type': 'application/json; charset=UTF-8' }
            }
          )
            .then((response) => {
              let soap = response.request.response
              let parser = new DOMParser()
              let xmlDoc = parser.parseFromString(soap, 'text/xml')
              if (xmlDoc.getElementsByTagName('MSG')[0].innerHTML && xmlDoc.getElementsByTagName('MSG')[0].innerHTML.includes('https://')) {
                window.location.href = xmlDoc.getElementsByTagName('MSG')[0].innerHTML.replace('requests#/accept?request_uuid=', 'online2/init/')
              } else {
                let status = parseInt(xmlDoc.getElementsByTagName('RETCODE')[0].innerHTML)
                switch (status) {
                  case 1: {
                    let notifData = {
                      name: this.name,
                      phone: this.phone.replace(/[^0-9]/g, ''),
                      sum: this.sum.replace(/[^0-9]/g, ''),
                      appNum: this.appNum
                    }
                    this.axios.post(
                      './sendEmailNotification.php',
                      notifData,
                      {
                        headers: {
                          'Content-Type': 'application/json; charset=UTF-8'
                        }
                      }
                    ).then((response) => {
                      this.$store.dispatch('switchStatus', 1)
                    })
                      .catch((error) => {
                        console.log(error)
                      })
                    break
                  }
                  case 0: {
                    this.$store.dispatch('switchStatus', 3)
                    break
                  }
                  case -1: {
                    this.$store.dispatch('switchStatus', 2)
                    break
                  }
                  case 2: {
                    this.$store.dispatch('switchStatus', 7)
                    break
                  }
                  case 3: {
                    this.$store.dispatch('switchStatus', 4)
                    break
                  }
                  case 4: {
                    this.$store.dispatch('switchStatus', 5)
                    break
                  }
                  case 5: {
                    this.$store.dispatch('switchStatus', 6)
                    break
                  }
                  default: {
                    this.$store.dispatch('switchStatus', 7)
                    break
                  }
                }
              }
            })
            .catch((error) => {
              console.log(error)
              if (error.request !== undefined && error.request !== null) {
                if (error.request.status === 404) {
                  this.disabled = false
                  this.$store.dispatch('setErrorMsg')
                }
              } else if (error.message !== null) {
                if (error.message === "Unable to get property 'innerHTML' of undefined or null reference") {
                  this.$store.dispatch('switchStatus', 1)
                } else if (error.message === 'i.getElementsByTagName(...)[0] is undefined') {
                  this.$store.dispatch('switchStatus', 1)
                }
              } else {
                this.$store.dispatch('setErrorMsg')
              }
            })
        }
      })
    },
    makeid () {
      let date = new Date()
      this.appNum = '9' + date.getSeconds() + date.getHours() + date.getFullYear() + date.getMonth() + date.getDate() + date.getMinutes() + date.getSeconds()
      return this.appNum
    },
    getAge (dateString) {
      let today = new Date()
      let birthDate = new Date(dateString)
      let age = today.getFullYear() - birthDate.getFullYear()
      let m = today.getMonth() - birthDate.getMonth()
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--
      }
      return age
    },
    compareDate () {
      if (this.getAge(this.cutIdn) >= 18) {
        this.isAdult = true
      } else {
        this.isAdult = false
      }
    }
  },
  watch: {
    sum: function (val) {
      if (this.sum !== null && this.sum !== undefined) {
        this.formatedSum = this.sum.replace(/[^0-9]/g, '')
      }
      if (parseInt(this.formatedSum) >= 10000 && parseInt(this.formatedSum) <= 1500000) {
        this.isValidSum = true
      } else {
        this.isValidSum = false
      }
    },
    idn: function (val) {
      if (this.idn.length >= 6) {
        let suffix = '19'
        if (this.idn[0] === '0' || this.idn[0] === '1') {
          suffix = '20'
        }
        this.cutedIdn = suffix + this.idn[0] + this.idn[1] + '-' + this.idn[2] + this.idn[3] + '-' + this.idn[4] + this.idn[5]
        this.getAge(this.cutedIdn)
        this.compareDate()
      } else {
        this.isAdult = false
      }
    },
    phone: function (val) {
      let formatedPhone = this.phone.replace(/[^0-9]/g, '')
      if (formatedPhone.length !== 10) {
        this.validPhone = false
      } else {
        this.validPhone = true
      }
    },
    termsAgree: function (val) {
      if (this.termsAgree === true) {
        this.disabled = false
      } else {
        this.disabled = true
      }
    }
  },
  computed: {
    calculatePayment: function () {
      return this.formatedSum * this.coef
    },
    cutIdn: function () {
      let suffix = '19'
      if (this.idn[0] === '0' || this.idn[0] === '1') {
        suffix = '20'
      }
      return suffix + this.idn[0] + this.idn[1] + '-' + this.idn[2] + this.idn[3] + '-' + this.idn[4] + this.idn[5]
    }
  }
}
</script>

<style lang="scss" scoped>
  #form {
    width: 100%;
    h1 {
      color: #000;
      font-size: 24px;
      line-height: normal;
    }
    h2 {
      font-family: 'AvantGardeGothicC';
      line-height: normal;
      font-size: 30px;
      color: #000;
      margin-bottom: 0;
    }
    .flex-column {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      position: relative;
      &.error {
        input {
          border-color: #DB1E31;
        }
      }
      input {
        font-family: 'SegoeUI';
        font-weight: 100;
        width: 100%;
        height: 62px;
        border-radius: 6px;
        box-sizing: border-box;
        border: 1px solid #A7A7A7;
        line-height: 62px;
        padding: 0 20px;
        background: transparent;
        font-size: 24px;
        color: #000;
      }
      div {
        width: 100%;
      }
    }
    label, h3 {
      font-family: 'SegoeUI';
      font-weight: 400;
      font-size: 24px;
      line-height: normal;
      color: #000;
      margin-bottom: 20px;
      margin-top: 20px;
    }
    .total_counter {
      opacity: 0;
      transition: all 0.2s ease-in-out;
      &.show {
        opacity: 1;
      }
      h3 {
        margin-bottom: 2px;
      }
      p {
        font-family: 'AvantGardeGothicC';
        font-size: 24px;
        color: #000;
        line-height: normal;
        margin: 0;
      }
    }
    .button-groups {
      display: flex;
      justify-content: space-between;
        button {
          font-family: 'AvantGardeGothicC';
          font-size: 24px;
          color: #000;
          line-height: normal;
          border-radius: 6px;
          box-sizing: border-box;
          border: 1px solid #a7a7a7;
          padding: 15px;
          background: #ffffff;
          outline: none;
          cursor: pointer;
          transition: all 0.4s ease-in-out;
        }
        .button-selected {
          background: #DB1E31;
          color: #ffffff;
          border: 1px solid #DB1E31;
          transition: all 0.2s ease-in-out;
        }
    }
    .phone_num_holder {
      display: flex;
      justify-content: space-between;
      align-items: center;
      label {
        margin: 0 28px 0 0;
      }
    }
    .agreement-check {
      position: relative;
      .agreement-check-holder {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin: 20px 0 45px;
      }
      .checkbox {
        max-width: 25px;
        width: 100%;
        height: 25px;
        border: 1px solid #DB1E31;
        box-sizing: border-box;
        border-radius: 100%;
        cursor: pointer;
        margin-right: 28px;
        overflow: hidden;
        background-color: #fff;
        transition: all 0.2s ease-in-out;
      }
      .checkbox::after {
        content: '';
        display: block;
        background: url('../assets/icons/baseline-done-24px.svg') 50% 100% no-repeat;
        transform: translateY(0);
        transition: all 0.2s ease-in-out;
        width: 100%;
        height: 200%;
      }
      .checked {
        background-color: #DB1E31;
      }
      .checked::after {
        background-size: 100% auto;
        transform: translateY(-50%);
      }
      p {
        font-family: 'SegoeUI';
        font-weight: 100;
        font-size: 12px;
        color: #000;
        margin: 0;
      }
    }
    .submit {
      font-family: 'Roboto';
      font-weight: 500;
      font-size: 24px;
      text-align: center;
      text-transform: uppercase;
      color: #ffffff;
      background: #DB1936;
      border: 1px solid #DB1936;
      border-radius: 6px;
      display: block;
      margin: 20px auto;
      padding: 23px 120px;
      transition: all 0.3s ease-in-out;
      outline: none;
    }
    .submit:hover {
      transform: scale(1.05)
                 translate3d(0,0,0);
      transition: all 0.1s ease-in-out;
    }
    .submit:disabled {
      opacity: 0.7;
      pointer-events: none;
    }
    input[type=text] {
      transition: all 0.3s ease-in-out;
      outline: none;
    }
    input[type=text]:focus {
      box-shadow: 0 0 10px rgba(167, 167, 167, 0.5);
    }
    #partners_code {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
  .error-msg {
    text-align: right;
    font-family: 'Roboto';
    font-weight: 500;
    font-size: 10px;
    color: #A81527;
    line-height: normal;
    right: 0;
    top: 50px;
    position: absolute;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .error-msg::before,
  .error-msg-terms::before {
    content: "!";
    display: block;
    border: 1px solid #A81527;
    border-radius: 50%;
    width: 15px;
    height: 15px;
    text-align: center;
    margin-right: 7px;
  }
  .error-msg-terms {
    font-family: 'Roboto';
    font-weight: 500;
    font-size: 10px;
    color: #A81527;
    line-height: normal;
    position: absolute;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    left: 0;
    bottom: -32px;
  }
  .hidden-total {
    opacity: 0;
  }

  @media only screen and (max-width: 768px) {
    .button-groups {
      flex-wrap: wrap;
      justify-content: flex-start;
      button {
        margin: 5px;
        flex-grow: 1;
        margin: 5px;
      }
    }
    #form {
      h2 {
        font-size: 24px;
        text-align: center;
      }
      .flex-column {
        label, input, h3 {
          font-size: 20px;
        }
        .error-msg {
          position: relative;
          right: unset;
          left: unset;
          bottom: unset;
          top: unset;
          font-size: 16px;
          justify-content: flex-start;
          text-align: left;
          margin-top: 15px;
        }
      }
      .button-groups {
        button {
          font-size: 20px;
        }
      }
      .total_counter {
        h3, p {
          font-size: 20px;
        }
      }
      .phone_num_holder {
        label {
          margin: 0 15px 0 0;
        }
      }
      .agreement-check {
        p {
          font-size: 16px;
        }
        .error-msg-terms {
          position: relative;
          top: unset;
          bottom: unset;
          right: unset;
          left: unset;
          font-size: 16px;
        }
      }
      .error-msg::before,
      .error-msg-terms::before {
        height: 20px;
        min-width: 20px;
        width: 20px;
      }
      .submit {
        padding: 20px;
        font-size: 20px;
      }
    }
  }
</style>
